<div class="container">
  <div mat-dialog-content>
    <div mat-dialog-title class="header3">Add Report</div>
    <form
      [formGroup]="reportForm"
      autocomplete="off"
      novalidate
      (ngSubmit)="createReport(reportForm.value)"
      fxLayout="column wrap"
      fxLayoutAlign="center center"
      fxLayoutGap="10px"
    >
      <mat-form-field>
        <mat-label>Title</mat-label>
        <input matInput formControlName="name" id="name" type="text" />
        <mat-hint align="end">Not more then 60 characters long.</mat-hint>
        <mat-error *ngIf="hasError('name', 'required')"
          >Name is required</mat-error
        >
        <mat-error *ngIf="hasError('name', 'maxlength')"
          >You have more than 60 characters</mat-error
        >
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Report Type</mat-label>
        <mat-select formControlName="reportType">
          <mat-option [value]="'pbi'"> Power BI </mat-option>
          <mat-option [value]="'cognos'"> Other </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Report URL</mat-label>
        <input matInput formControlName="url" id="url" type="text" />
        <mat-error *ngIf="hasError('url', 'required')"
          >Url is required</mat-error
        >
      </mat-form-field>
      <mat-form-field *ngIf="reportForm && reportForm.value.reportType === 'pbi'">
        <mat-label>Dataset URL</mat-label>
        <input
          matInput
          formControlName="datasetUrl"
          id="datasetUrl"
          type="text"
        />
      </mat-form-field>
      <mat-form-field>
        <mat-label>ASMS</mat-label>
        <input matInput formControlName="asms" id="name" type="text" />
        <mat-error *ngIf="hasError('asms', 'required')"
          >ASMS is required</mat-error
        >
        <mat-error *ngIf="hasError('asms', 'maxlength')"
          >You have more than 60 characters</mat-error
        >
      </mat-form-field>
      <div class="custom-error" *ngIf="addError && addError.includes('User')">
        User not found
      </div>
      <mat-form-field>
        <mat-label>Report Owner (gmid or email)</mat-label>
        <input matInput formControlName="reportOwner" id="name" type="text" />
        <!-- <mat-hint align="end">Not more then 60 characters long.</mat-hint> -->
        <mat-error *ngIf="hasError('reportOwner', 'required')"
          >Report Owner is required</mat-error
        >
        <mat-error *ngIf="hasError('reportOwner', 'maxlength')"
          >You have more than 60 characters</mat-error
        >
      </mat-form-field>
      <mat-form-field>
        <mat-label>Description</mat-label>
        <textarea
          matInput
          formControlName="description"
          id="description"
          type="text"
        ></textarea>
        <mat-hint align="end">Atleast 40 Characters</mat-hint>
        <mat-error *ngIf="hasError('description', 'required')"
          >Description is required</mat-error
        >
        <mat-error *ngIf="hasError('description', 'maxlength')"
          >Can't include more than 400 characters
        </mat-error>
        <mat-error *ngIf="hasError('description', 'minlength')"
          >Must be atleast 40 characters</mat-error
        >
      </mat-form-field>
    </form>
    <section>
      <div class="info-text">Countries with access:</div>
      <mat-list>
        <mat-list-item *ngFor="let country of countries">
          <mat-checkbox [(ngModel)]="country.hasAccess"
            >{{country.fullName}}</mat-checkbox
          >
        </mat-list-item>
      </mat-list>
    </section>
  </div>
  <div class="button-container" mat-dialog-actions>
    <button mat-raised-button (click)="onNoClick()">Close</button>
    <button
      mat-raised-button
      cdkFocusInitial
      color="accent"
      [disabled]="!reportForm.valid"
      (click)="createReport(reportForm.value)"
    >
      Add
    </button>
  </div>
</div>
